import React from 'react';

export default function TenureIcon({
  width = 48,
  height = 48,
  fill = '#9F9FA0',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_10015_20307)">
        <path
          d="M44.5673 14.604V33.4274C47.7643 34.5205 48.9908 38.334 47.1189 41.1631C46.3261 42.3619 45.1927 42.962 43.8389 43.3435C39.7674 44.4908 35.321 45.0223 31.2181 46.144L13.2022 46.1782C12.7471 47.047 11.7454 47.74 10.7579 47.8543C9.11932 48.0443 4.48404 48.0557 2.86978 47.8385C1.43726 47.6442 0.182202 46.344 0.0147654 44.9137L-0.000976562 27.0605C0.104924 25.4931 1.39004 24.1043 2.95994 23.9214C4.69441 23.7199 8.9018 23.7371 10.6606 23.9114C11.7983 24.0243 12.7214 24.7073 13.3081 25.6532L13.7145 26.6905V14.6055C13.3868 14.7241 13.1321 15.0184 12.823 15.1584C10.9998 15.9871 9.43989 13.7739 10.8724 12.3551L28.5463 0.0528666L29.5767 0C35.6216 3.93785 41.4676 8.24147 47.4109 12.3551C48.8419 13.7739 47.2835 15.9871 45.4603 15.1584C45.1512 15.0184 44.8964 14.7226 44.5687 14.6055L44.5673 14.604ZM17.1434 12.1979V27.332H20.5709V23.2141C20.5709 20.9337 23.3014 18.9191 25.4394 18.7705C27.5059 18.6262 30.8904 18.6119 32.9469 18.7705C35.0033 18.9291 37.7095 20.998 37.7095 23.2127V33.8546L41.137 33.3188L41.1441 12.5108L41.0382 12.0822L29.103 3.82211L17.142 12.1965L17.1434 12.1979ZM34.2835 34.1775V23.6428C34.2835 23.1098 33.5694 22.4454 33.0571 22.3011C32.217 22.0639 26.5871 22.0697 25.5625 22.2083C23.0982 22.544 24.2588 26.2804 24.0112 27.9636C25.5568 28.3679 27.3184 28.3808 28.7051 29.2124C30.3767 30.214 31.1995 32.2658 30.7487 34.1775H34.2835ZM10.2885 27.332H3.43219V44.4451H10.2885V27.332ZM13.716 30.7541V42.7333H30.8017L43.4654 39.87C45.3558 39.0041 44.7404 36.4108 42.5867 36.5322C40.556 36.6465 38.2304 37.441 36.1625 37.6039L18.5087 37.5739C16.5509 37.0681 16.7227 34.3561 18.8006 34.1732C21.2563 33.9575 24.004 34.3647 26.4927 34.1518C27.7463 33.7732 27.7506 32.3744 26.4669 31.9829C25.0845 31.5613 21.8331 30.9041 20.3991 30.7684C18.2668 30.564 15.8769 30.8927 13.7174 30.7555L13.716 30.7541Z"
          fill={fill}
        />
        <path
          d="M27.0777 11.9565C27.8733 11.8236 30.0658 11.8522 30.913 11.9265C33.124 12.1208 33.0467 15.0813 31.1133 15.3442C30.3076 15.4542 28.088 15.4457 27.2666 15.3542C25.2287 15.127 25.2444 12.2651 27.0777 11.9565Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_10015_20307">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
